import { Checkbox, Form, Input, Modal, Select, message } from "antd";
import { formatError } from "common/redux/middleware/queryErrorLogger";
import { useAddDebtorTagMutation, useUpdateDebtorTagMutation } from "features/tags/tagsAPI";
import { useFetchRolesQuery } from "features/userManagementTable/userManagementAPI";
import styled from "styled-components";

const StyledForm = styled(Form)`
  margin-top: 12px;
  max-width: 450px;
`;

export default function AddDebtorTagModal({ title, open, onOk, onCancel, debtorTag }) {
  const [form] = Form.useForm();
  const [addDebtorTag] = useAddDebtorTagMutation();
  const [updateDebtorTag] = useUpdateDebtorTagMutation();
  const { data: roles } = useFetchRolesQuery({ userType: "agency" });

  const initialValues = {
    ...debtorTag,
  };

  const onSubmit = async () => {
    const action = debtorTag ? updateDebtorTag : addDebtorTag;
    const formData = await form.validateFields();

    const result = await action({ ...formData });
    if ("data" in result) {
      const successMessage = debtorTag
        ? "Debtor tag updated successfully."
        : "Debtor tag added successfully.";
      message.success(successMessage);
      onOk();
      form.resetFields();
    }
    if ("error" in result) {
      form.setFields(formatError(result.error));
    }
  };

  return (
    <Modal
      maskClosable={false}
      title={title}
      open={open}
      okText="Submit"
      onOk={onSubmit}
      onCancel={onCancel}
    >
      <StyledForm
        form={form}
        layout="vertical"
        labelAlign="left"
        initialValues={initialValues}
        validateMessages={{ required: "This is a required field" }}
      >
        <Form.Item name="id" hidden>
          <Input hidden />
        </Form.Item>
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="notes" label="Notes / Description">
          <Input />
        </Form.Item>
        <Form.Item
          name="isSuppressFromCreditReporting"
          valuePropName="checked"
          tooltip="Accounts associated with debtors with this tag will be suppressed from credit reporting"
        >
          <Checkbox>Suppress from credit reporting</Checkbox>
        </Form.Item>
        <Form.Item
          name="isDeleteFromCreditReporting"
          valuePropName="checked"
          tooltip="Accounts associated with debtors with this tag will be deleted from credit reporting"
        >
          <Checkbox>Delete from credit reporting</Checkbox>
        </Form.Item>
        <Form.Item
          name="isExcludeFromConsumerPortal"
          valuePropName="checked"
          tooltip="Accounts associated with debtors with this tag will be hidden from the consumer portal"
        >
          <Checkbox>Exclude from consumer portal</Checkbox>
        </Form.Item>
        <Form.Item
          name="isExcludeFromCommunication"
          valuePropName="checked"
          tooltip="Debtors with this tag will be excluded from receiving communications"
        >
          <Checkbox>Exclude from communication</Checkbox>
        </Form.Item>
        <Form.Item
          name="addableByGroupIds"
          label="Roles Allowed to Add Tag"
          tooltip="If empty, all roles can add this tag to debtors"
        >
          <Select
            mode="multiple"
            allowClear
            placeholder="All Roles"
            options={roles?.map((role) => ({
              value: role.id,
              label: role.name,
            }))}
          />
        </Form.Item>
        <Form.Item
          name="removableByGroupIds"
          label="Roles Allowed to Remove Tag"
          tooltip="If empty, all roles can remove this tag from debtors"
        >
          <Select
            mode="multiple"
            allowClear
            placeholder="All Roles"
            options={roles?.map((role) => ({
              value: role.id,
              label: role.name,
            }))}
          />
        </Form.Item>
      </StyledForm>
    </Modal>
  );
}
